import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AccountProvider } from "./context/Account";
import { Unauthorized } from "./pages/unauthorized";
import Flow from "./components/Flow/Flow";
import AnalyticsFlow from "./components/Analytics/AnalyticsFlow";
import { Intro } from "./pages/intro";
import { NotFound } from "./pages/notFound";

function App() {
	console.log("=== DEBUG ENV VARS ===");
	console.log("REACT_APP_AMBIENT:", process.env.REACT_APP_AMBIENT);
	console.log("NODE_ENV:", process.env.NODE_ENV);
	console.log(
		"All REACT_APP vars:",
		Object.keys(process.env).filter((key) => key.startsWith("REACT_APP"))
	);
	console.log("======================");
	return (
		<BrowserRouter>
			<AccountProvider>
				<Routes>
					<Route path="/" element={<Intro />}></Route>
					<Route
						path="/builder/:botId/analytics/chat/:chatId"
						element={<AnalyticsFlow />}
					/>
					<Route path="/builder/:botId/analytics" element={<AnalyticsFlow />} />
					<Route path="/builder/:botId" element={<Flow />}></Route>
					<Route path="/unauthorized" element={<Unauthorized />}></Route>
					<Route path="*" element={<NotFound />}></Route>
				</Routes>
			</AccountProvider>
		</BrowserRouter>
	);
}

export default App;
